export const New = () => {
  return <span style={{ color: "blue", fontSize: "12px" }}>New !</span>;
};
